import { memo } from 'react';

import ImageIconSVG from '@/assets/image-icon.svg?react';
import { Icon, IconProps } from '@/components/core';

const IImageIcon = (props: Omit<IconProps, 'SVGComponent'>) => <Icon SVGComponent={ImageIconSVG} {...props} />;

export const ImageIcon = memo(IImageIcon) as typeof IImageIcon;
